<template>
  <div>
    <template v-if="layout === 'home'">
      <div class="w3-col s12 m6 l4 profile" v-for="article of $options.filters.limit($options.filters.sort(news, 'date'), 6)" :key="article.uid">
        <div v-if="article.image != ''" :ref="article.articleid" class="card" @click="articleNav(article)">
          <div class="cardheader" v-bind:style="{'background-image': 'url(' + article.image + ')'}"></div>
          <div class="info">
            <div class="bold truncate">{{article.title}}</div>
            <div class="eventDate">{{article.date * 1000 | date('day')}}</div>
            <div style="padding:0 20px;">
              <hr />
            </div>
            <div class="desc">{{article.content | truncate(150)}}</div>
            <div class="articleDetailsLink">
              ARTICLE DETAILS
            </div>
          </div>
        </div>
      </div>
    </template>
    <template v-if="layout === 'wide'">
      <!-- TODO: 3 most recent news articles -->
      <div class="w3-col s12 m6 l4 profile" v-for="article of $options.filters.limit(news, 3)" :key="article.uid">
        <div v-if="article.image != ''" :ref="article.articleid" class="card" @click="articleNav(article)">
          <div class="cardheader" v-bind:style="{'background-image': 'url(' + article.image + ')'}"></div>
          <div class="info">
            <div class="bold truncate">{{article.title}}</div>
            <div class="eventDate">{{article.date * 1000 | date('day')}}</div>
            <div style="padding:0 20px;">
              <hr />
            </div>
            <div class="desc">{{article.content | truncate(150)}}</div>
            <div class="articleDetailsLink">
              ARTICLE DETAILS
            </div>
          </div>
        </div>
      </div>
      <!-- TODO: all other articles by date -->
      <div class="w3-col s12 m6 l4 profile" v-for="article of $options.filters.sort(news, 'date')" :key="article.uid">
        <div v-if="article.image != ''" :ref="article.articleid" class="card" @click="articleNav(article)">
          <div class="cardheader" v-bind:style="{'background-image': 'url(' + article.image + ')'}"></div>
          <div class="info">
            <div class="bold truncate">{{article.title}}</div>
            <div class="eventDate">{{article.date * 1000 | date('day')}}</div>
            <div style="padding:0 20px;">
              <hr />
            </div>
            <div class="desc">{{article.content | truncate(150)}}</div>
            <div class="articleDetailsLink">
              ARTICLE DETAILS
            </div>
          </div>
        </div>
      </div>
    </template>
    <!-- <template v-if="layout === 'search'">
      <ul class="event-list pointer" ref="eventlist">
        <li class="eventItem" v-for="(event, index) of eventList" :key="index" :style="{'animation-delay': (index * .2) + 's'}">
          <time :datetime="event.start" @click="eventPreview(event)">
            <template v-if="event.dates.length > 0">
              <span class="day">{{event.dates[0].date | date('dayNumber')}}</span>
              <span class="month">{{event.dates[0].date | date('monthStringShort')}}</span>
              <span class="year">{{event.dates[0].date | date('year')}}</span>
            </template>
          </time>
          <img v-if="event.image !== ''" :alt="event.title" :src="event.image" @click="eventPreview(event)" />
          <div class="info" @click="eventPreview(event)">
            <h2 class="title">{{event.title}}</h2>
            <p class="desc lato">{{event.description | truncate(200)}}</p>
          </div>
        </li>
      </ul>
    </template> -->
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'events',
  props: {
    layout: String,
    limit: Number
  },
  data() {
    return {
      dataLoaded: false,
      showPreview: false,
      width: window.innerWidth,
    }
  },
  computed: {
    ...mapState([
      'news',
      'initSearch'
    ])
  },
  created() {
    this.$store.dispatch('getNews')
    this.$store.dispatch('getEvents')
  },
  mounted() {
    window.onresize = () => {
      this.width = window.innerWidth
    }
  },
  methods: {
    articleNav(news) {
      this.$router.push({ name: 'news-details', params: {url: news.url} })
      window.scrollTo(0, 0)
    }
  }
}
</script>

<style scoped>
</style>
